import {
  ADVERTISING_CONSENT_CHOICES,
  ADVERTISING_CONSENT_STORAGE_KEY,
  type AdvertisingConsentChoice,
} from "@/lib/advertisingConsent";
import { Cookies } from "@garimpa/lib/cookies";
import { readCookie } from "@garimpa/lib/readCookie";

export function readAdvertisingConsent(
  storage?: Pick<Storage, "getItem"> | null,
  cookieHeader?: string | null,
): AdvertisingConsentChoice | null {
  try {
    const cookies = cookieHeader ?? (typeof document === "undefined" ? null : document.cookie);
    const cookieValue = readCookie(cookies, Cookies.advertisingConsent);
    const cookieChoice = ADVERTISING_CONSENT_CHOICES.find((value) => value === cookieValue);
    if (cookieChoice) return cookieChoice;

    const target = storage ?? (typeof window === "undefined" ? null : window.localStorage);
    const choice = target?.getItem(ADVERTISING_CONSENT_STORAGE_KEY);
    return ADVERTISING_CONSENT_CHOICES.find((value) => value === choice) ?? null;
  } catch {
    return null;
  }
}
